import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ImageOriginSliceState {
  imageOrigin: string;
}

export const imageOriginInitialState: ImageOriginSliceState = {
  imageOrigin: '',
};

const imageOriginSlice = createSlice({
  name: 'imageOrigin',
  initialState: imageOriginInitialState,
  reducers: {
    setImageOrigin: (state, action: PayloadAction<string | undefined>) => {
      state.imageOrigin = action.payload ?? '';
    },
  },
});

export const { setImageOrigin } = imageOriginSlice.actions;

export const imageOriginReducer = imageOriginSlice.reducer;

export const imageOriginSelector = <
  S extends { imageOrigin: ImageOriginSliceState },
>(
  state: S
) => state.imageOrigin;
